import { Component } from '@angular/core';

import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-upload-confirmation',
    templateUrl: './upload-confirmation.component.html',
    styleUrl: './upload-confirmation.component.scss',
    standalone: true,
    imports: [CommonModule]
})
export class UploadConfirmationComponent {

}
